const EIR_POSTCODE_PATTERN = '\\b(?:(' +
    'a(4[125s]|6[37]|7[5s]|[8b][1-6s]|9[12468b])|' +
    'c1[5s]|' +
    'd([0o][1-9sb]|1[0-8osb]|2[024o]|6w)|' +
    'e(2[15s]|3[24]|4[15s]|[5s]3|91)|' +
    'f(12|2[368b]|3[15s]|4[25s]|[5s][26]|9[1-4])|' +
    'h(1[2468b]|23|[5s][34]|6[25s]|[79]1)|' +
    'k(3[246]|4[5s]|[5s]6|67|7[8b])|' +
    'n(3[79]|[49]1)|' +
    'p(1[247]|2[45s]|3[126]|4[37]|[5s][16]|6[17]|7[25s]|[8b][15s])|' +
    'r(14|21|3[25s]|4[25s]|[5s][16]|9[35s])|' +
    't(12|23|34|4[5s]|[5s]6)|' +
    'v(1[45s]|23|3[15s]|42|9[2-5s])|' +
    'w(12|23|34|91)|' +
    'x(3[5s]|42|91)|' +
    'y(14|2[15s]|3[45s])' +
    ')\\s?[abcdefhknoprtsvwxy\\d]{4})\\b';

const NI_POSTCODE_PATTERN = '\\b(BT([1-9]|[1-4]\\d|5[1-8]|6\\d|7[014-9]|8[0-2]|9[2-49])\\s?\\d[A-Z]{2})\\b';

export class PostcodeModel {
    public readonly code: string;

    constructor(postcode: string) {
        this.code = this.normalizePostcode(postcode);
    }

    public get isEirCode(): boolean {
        let reg = new RegExp(EIR_POSTCODE_PATTERN);

        return reg.test(this.code.toLowerCase());
    }

    public get isNorthernIrelandPostcode(): boolean {
        let reg = new RegExp(NI_POSTCODE_PATTERN);

        return reg.test(this.code.toUpperCase());
    }

    public isEqual(postcode: PostcodeModel | null | undefined): boolean {
        return this.code.replace(' ', '') === postcode?.code?.replace(' ', '');
    }

    private normalizePostcode(source: string): string {
        let postcode = source.toUpperCase().trim();

        return postcode;
    }
}